import { BehaviorParameters } from 'rangeConfig/@types';
import { HierarchyUtils } from '@inter-ikea-core/core';
import { ProductType } from '@inter-ikea-storageone/range';

const removeFrameDrawer = ({ coreApi }: BehaviorParameters) => {
  const frame = coreApi.entities.findSelectedEntity();

  if (frame) {
    const existingDrawer = HierarchyUtils.children(frame).find(child =>
      coreApi.entities.isProductType(child, ProductType.SMASTAD_FRAME_DRAWER_NA)
    );
    if (existingDrawer) {
      coreApi.entities.delete(existingDrawer);
    }
  }
};

export default removeFrameDrawer;
